<!--component html goes here -->
<app-header></app-header>
  
<!-- <section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/visa.jpg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
      <div class="row mt-5 justify-content-center">
          <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> Visas </h4>
              </div>
          </div> 
      </div>
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a>Visas</a></li>
              </ul>
          </nav>
      </div>
  </div> 
</section> -->
<!--end section-->
        <!-- <div class="position-relative">
            <div class="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div> -->
          <!-- Hero Start -->
      
        <!-- Hero End -->

<section class="bg-half" id="home">
 
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
            <div class="section-title text-center mb-4 pb-2">
                <h4 class="title mb-4">Visas <span class="text-primary">Information Results</span></h4>
                <p class="text-muted para-desc mx-auto mb-0">You can view the <span
                        class="text-primary fw-bold">visa Information</span> that can provide everything you need</p>
            </div>
        </div>
        <!--end col-->
    </div>
      <div class="row container-grid projects-wrapper">
        <div class="col-lg-6 col-12 mb-4 pb-2 spacing mt-3 branding" *ngFor="let data of rows">
          <div class="card blog blog-primary rounded border-0 shadow overflow-hidden">
            <div class="row align-items-center g-0">
              <div class="col-md-6">
                <img src="{{data.images}}" class="img-fluid" style="height: 200px; width: 100%;" alt="" routerLink="/visa-details/{{data.id}}">
                <!-- <div class="overlay bg-dark"></div> -->
                <div class="author">
                  <small class="user d-block"><i class="uil uil-map"></i> {{data.countryNameEn}}</small>
                </div>
              </div>
              <!--end col-->
  
              <div class="col-md-6" routerLink="/visa-details/{{data.id}}">
                <div class="card-body content">
                  <h5><a href="javascript:void(0)" class="card-title title text-dark" >{{data.titleEn}}</a>
                  </h5>
                  <p class="text-muted mb-0" style="height: 100px; overflow: hidden;">{{data.descriptionEn}}</p>
                  <div class="post-meta d-flex justify-content-between mt-3">
                    <!-- <ul class="list-unstyled mb-0">
                      <li class="list-inline-item me-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i
                            class="uil uil-heart me-1"></i>{{data.like}}</a></li>
                      <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i
                            class="uil uil-comment me-1"></i>{{data.message}}</a></li>
                    </ul> -->
                    <a routerLink="/visa-details/{{data.id}}" class="text-muted readmore">Read More <i
                        class="uil uil-angle-right-b align-middle"></i></a>
                  </div>
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
          </div>
          <!--end blog post-->
        </div>
        <!--end col-->
        <!-- PAGINATION START -->
        <div class="col-12">
          <ul class="pagination justify-content-center mb-0">
            <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous">Prev</a></li>
            <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
            <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next</a></li>
          </ul>
        </div>
        <!--end col-->
        <!-- PAGINATION END -->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </section>